import React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchableMultiSelect } from '@shared/components/SearchableMultiSelect';
import type { VoiceDto } from '@shared/services/apiService/apiService';
import {
  resolveVoiceProviderDisplayName,
  voiceMatchesProviderQuery,
} from '@shared/utils/voiceDisplay';

type SelectVoicesInputProps = {
  voices: VoiceDto[] | undefined;
  selectedIds: string[];
  onChange: (nextIds: string[]) => void;
  disabled?: boolean;
  portalDropdown?: boolean;
};

function voiceMatchesQuery(voice: VoiceDto, query: string) {
  return voice.name.toLowerCase().includes(query) || voiceMatchesProviderQuery(voice, query);
}

export const SelectVoicesInput: React.FC<SelectVoicesInputProps> = ({
  voices,
  selectedIds,
  onChange,
  disabled,
  portalDropdown = false,
}) => {
  const { t } = useTranslation();

  return (
    <SearchableMultiSelect
      items={voices}
      selectedIds={selectedIds}
      onChange={onChange}
      disabled={disabled}
      portalDropdown={portalDropdown}
      listboxId="select-voices-listbox"
      getLabel={(voice) => voice.name}
      getBadge={resolveVoiceProviderDisplayName}
      matchesQuery={voiceMatchesQuery}
      placeholder={t('superAdminMainPage.companies.selectVoicesInput.placeholder')}
      emptyLabel={t('campaignPage.voicePicker.empty')}
      getRemoveLabel={(name) =>
        t('superAdminMainPage.companies.selectVoicesInput.removeVoice', { name })
      }
    />
  );
};
